import {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {useLocation} from 'react-router-dom'
import {RELEVANCE_SORT_ID} from '../constants'
import {useSortUrls} from './use-sort-urls'

/*
 * Prepends the frontend-only "Relevance" option to the SFCC sorting options.
 * The selected option comes from the url `sort` param; no param means relevance.
 */
export const useSortingOptions = (productSearchResult) => {
    const intl = useIntl()
    const location = useLocation()
    const backendOptions = productSearchResult?.sortingOptions

    const sortingOptions = useMemo(() => {
        if (!backendOptions?.length) return []
        return [
            {
                id: RELEVANCE_SORT_ID,
                label: intl.formatMessage({
                    id: 'product_list.sort.relevance',
                    defaultMessage: 'Relevance'
                })
            },
            ...backendOptions.filter((option) => option.id !== RELEVANCE_SORT_ID)
        ]
    }, [backendOptions, intl])

    const sortUrls = useSortUrls({options: sortingOptions})

    const urlSort = new URLSearchParams(location.search).get('sort')
    const selectedSortingOption = sortingOptions.some((option) => option.id === urlSort)
        ? urlSort
        : RELEVANCE_SORT_ID

    return {sortingOptions, sortUrls, selectedSortingOption}
}
